var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M16.527 4.11c-.21 1.371-.046 3.425 1.097 5.113 1.114 1.645 3.236 3.06 7.19 3.06h.603v1.38h-.69c-3.953 0-6.075 1.414-7.19 3.06-1.142 1.687-1.307 3.741-1.096 5.113l-1.363.21c-.25-1.618-.07-4.048 1.317-6.097a7.53 7.53 0 0 1 2.453-2.286H.583v-1.38h18.351a7.53 7.53 0 0 1-2.452-2.286c-1.387-2.05-1.567-4.48-1.318-6.097l1.364.21Z","clipRule":"evenodd"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 26 26","fill":"currentColor"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
